import { BadgeCheck, Headphones, RefreshCcw, ShieldCheck, Zap } from "lucide-react";

const GUARANTEES = [
  { icon: ShieldCheck, title: "Paiement sécurisé", text: "Moyens de paiement fiables" },
  { icon: Zap, title: "Livraison instantanée", text: "Réception immédiate après paiement" },
  { icon: BadgeCheck, title: "Licences vérifiées", text: "Origine indiquée sur chaque fiche" },
  { icon: Headphones, title: "Support 24/7", text: "Assistance rapide et efficace" },
  { icon: RefreshCcw, title: "Garantie produit", text: "Selon les conditions du produit" },
];

export function TrustStrip({ overlap = true }) {
  return (
    <div className={`container-it relative z-30 ${overlap ? "-mt-14" : "mt-10"}`}>
      <div
        data-testid="trust-strip"
        className="grid grid-cols-2 gap-x-4 gap-y-6 rounded-2xl border border-line bg-white p-6 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.25)] md:grid-cols-3 lg:grid-cols-5 lg:divide-x lg:divide-line lg:p-7"
      >
        {GUARANTEES.map(({ icon: Icon, title, text }, i) => (
          <div key={title} className={`flex items-start gap-3 ${i > 0 ? "lg:pl-6" : ""}`}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand">
              <Icon className="h-5 w-5" strokeWidth={2.1} />
            </span>
            <span>
              <span className="block text-[13.5px] font-bold leading-tight text-ink">{title}</span>
              <span className="mt-1 block text-xs leading-snug text-slate-500">{text}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TrustStrip;
